<template>
    <div v-if="$root.setting.business">
        <v-select
            data-top-right-id="business-whitelist"
            v-if="staffIsWhitelist"
            ref="select"
            id="search_business"
            name="search_business"
            label="name"
            :placeholder="currentBusinessName"
            :noDrop="isDisableDrop"
            :options="options"
            :class="{
                search: true,
                'nav-search': true,
                businesses: true,
                ci: isCI
            }"
            @search="onSearch"
            @input="businessSwitchBusiness"
        >
            <template v-slot:option="{ name , instance_type}">
                <b v-if="instance_type == 5">{{ name }} (G)</b>
                <b v-else>{{ name }}</b>
            </template>
            <template v-slot:selected-option="{ name, instance_type }">
                <span v-if="instance_type == 5">{{ name }} (G)</span>
                <span v-else>{{ name }}</span>
            </template>
        </v-select>
        <b-nav-item-dropdown
            v-else-if="businesses && businesses.length > 1"
            data-top-right-id="business"
            id="nav-item-business"
            :text="shortenName($root.setting.business.name)"
            :title="$root.setting.business.name"
            right
            class="business-select"
        >
            <b-dropdown-item
                v-for="business in businesses"
                :key="business.id"
                @click="switchBusiness(business.id)"
                href
            >
                <span class="box">
                    <span v-if="business.id == setting.business_id">✔</span>
                </span>
                {{ business.name }}
            </b-dropdown-item>
            <b-modal
                id="preventSwitchModal"
                ref="preventSwitchModal"
                :lazy="true"
                title-tag="h2"
                title="Login Restricted"
            >
                <!-- Modal Form -->
                {{ preventMessage }}
                <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-button
                            @click="$refs.preventSwitchModal.hide()"
                            variant="primary"
                            >Close</b-button
                        >
                    </div>
                </div>
            </b-modal>
        </b-nav-item-dropdown>
    </div>
</template>
<style lang="scss" scoped>
.business-select .box {
    width: 1rem;
    display: inline-block;
}

@media (min-width: 992px) {
    ::v-deep #nav-item-business ul.dropdown-menu {
        overflow: hidden;
        overflow-y: auto;
        max-height: calc(100vh - 100px);
    }
}
</style>
<script>
import { DateTime } from "luxon";
import vSelect from "vue-select";

export default {
    components: { vSelect },
    props: {
        setting: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            businesses: [],
            options: [],
            search: false,
            isDisableDrop: true,
            currentBusinessName: "",
            preventMessage: "Login permitted during clinic hours only"
        };
    },
    watch: {
        options(options = []) {
            let ul = document.querySelector(".search.businesses ul");

            if (options.length > 0) {
                ul.style.width = "unset";
                ul.style.left = "unset";
                ul.style.right = "0";
                ul.style.borderTopLeftRadius = "5px";
                ul.style.borderTopRightRadius = "5px";
            }
        }
    },
    mounted() {
        let self = this;

        self._getSetting().then(() => {
            self.$nextTick(() => {
                self.businessClicked();
                self.currentBusinessName =
                    self.$store.state.setting.business.instance_type == 5 ? self.$store.state.setting.business.name +' (G)' :
                    self.$store.state.setting.business.name;
            });
        });
    },
    computed: {
        isCI() {
            return this.$root.referer === "CI";
        },
        staffIsWhitelist() {
            return this.$root.currentActor.is_whitelist;
        }
    },
    methods: {
        shortenName(name) {
            const maxLength = 40;
            if (name.length > maxLength) {
                return name.slice(0, maxLength - 3) + "...";
            }
            return name;
        },
        businessSwitchBusiness(value) {
            this.switchBusiness(value.id);
        },
        onSearch(search) {
            if (search.length >= 3) {

                this.searchBusinesses(search);

                this.isDisableDrop = false;
            } else {
                this.isDisableDrop = true;
                this.options = [];
            }
        },
        searchBusinesses(search) {
            this.loading = true;

            let self = this;
            this.$http
                .get(
                    process.env.ACTOR_SERVICE +
                        "staff/search-businesses?query=" +
                        search
                )
                .then(response => {
                    self.businesses = response.data.response.resources;
                    self.options = Object.values(self.businesses);
                });
        },
        getBusinesses() {
            let self = this;
            if (!self.businesses.length) {
                this.$http
                    .get(process.env.ACTOR_SERVICE + "staff/businesses")
                    .then(response => {
                        self.businesses = response.data.response.resources;
                        // self.checkSwitchInstance();
                    });
            }
        },
        businessClicked() {
            if (!this.staffIsWhitelist) {
                this.getBusinesses();
            }
        },
        async switchBusiness(businessId) {
            document.body.style.cursor = "wait";
            const response = await $.getJSON(
                process.env.APPS + "index.php/ajax/business/checkAccess",
                { business_id: businessId }
            );
            if (response) {
                if (response.allowed) {
                    localStorage.removeItem("sf_username");
                    localStorage.removeItem("my_staff_url");
                    localStorage.setItem("Vetter-Token", response.token);

                    let res = await this.$http.get(
                        process.env.APPS +
                            "index.php/business/business/switch_instance?bid=" +
                            businessId +
                            "&redirect=0" // redirect = 0 tells the server to not use redirect (on the server side). let the client side handle the redirection
                    );

                    if (res?.data?.success) {
                        this.$socket.client.emit("v-broadcast-all", {
                            businessId: this.$root.setting.business_id,
                            userId: this.$root.currentActor.id,
                            action: "post-switch-instance",
                            url: res?.data?.url,
                            isAutomation: res?.data?.is_automation,
                            instance: localStorage.getItem("instance")
                        });
                    }
                } else {
                    // --- reset dialog
                    this.$root.$emit("bv::show::modal");
                    this.preventMessage = response.message;
                    this.$refs.preventSwitchModal.show();
                }
            }

            document.body.style.cursor = "";
            return response;
        }
        // VET-1028 - function moved to src/module/layout/index.vue
        // checkSwitchInstance() {
        //     let last_switch = this.$cookies.get("last_switch");
        //     let switcher_event = setInterval(() => {
        //         if (
        //             this.$store.state.setting &&
        //             this.$store.state.setting.business_id !==
        //                 this.$cookies.get("active_business_id") &&
        //             this.last_switch !== this.$cookies.get("last_switch")
        //         ) {
        //             clearInterval(switcher_event);
        //             this._redirect(
        //                 process.env.APPS + "index.php/welcome/redirect"
        //             );
        //         }
        //     }, 1000);
        // }
    }
};
</script>
